import { render, staticRenderFns } from "./AppConstract.vue?vue&type=template&id=c8afcc5a&scoped=true&"
var script = {}
import style0 from "./AppConstract.vue?vue&type=style&index=0&id=c8afcc5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8afcc5a",
  null
  
)

export default component.exports